import { createActionGroup, props } from "@ngrx/store";
import { DocViewerContextDoc } from "@models/ui/doc-viewer-context-doc.model";

export const documentListActions = createActionGroup({
	source: 'Document List',
	events: {
		'List Updated': props<{ newDocumentList: DocViewerContextDoc[], isExpandedResults: boolean }>(), 
	},
});
